document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll(
    '.lume-band, .lume-card, .lume-detail, .lume-benefits, .lume-signup-inner'
  );

  if (!targets.length) return;

  targets.forEach((el) => {
    el.classList.add('lume-reveal');
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.16,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  targets.forEach((el) => observer.observe(el));
});